import { MarketoConsentClientPort } from '../../application/ports/api/MarketoConsentClientPort';
import { MarketoPayload } from '../../clients';
import { MarketingConsent } from '../../frameworks_drivers/redux/reducers/onboardingInformation';
import { BaseAxiosClient } from './BaseAxiosClient';

export class MarketoConsentClient extends BaseAxiosClient implements MarketoConsentClientPort {
  constructor(private readonly baseUrl: string) {
    super(baseUrl);
  }

  async submitConsent(email: string, marketingConsent: MarketingConsent) {
    const payload: MarketoPayload = {
      email: email,
      marketingConsent: marketingConsent
    };

    return this.post('/api/preOptConsent', payload);
  }
}
